import HarIdxFrame from "../../components/HarIdxFrame";

export default function QuickSearchPage() {
  return (
    <HarIdxFrame
      eyebrow="HAR · Quick Search"
      title="Quick property search"
      description="Fast filters for price, beds, and neighborhoods across the Houston MLS."
      path="myquicksearch"
      extraParams="allmls=n"
      seoPath="/quick-search"
    />
  );
}
